<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="10rem"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">任务详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="计划名称" prop="name">
                <el-input v-model="data.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="路线名称" prop="routeName">
                <el-input v-model="data.routeName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间" prop="startdate">
                <el-input v-model="data.startdate" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="巡检时间" prop="singlePatroltime">
                <el-input v-model="data.singlePatroltime" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="巡检人" prop="staffName">
                <el-input v-model="data.staffName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="statusName">
                <el-input v-model="data.statusName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="22" :offset="2">
              <div style="display:flex;align-items:center;">
              <span class="item_title">巡检轨迹</span>
              <div id="mymap" class="mymap"></div>
              <div class="btn">
                <el-button
                  @click="hideTrail(0)"
                  v-show="SPatrolPointRecordList.length"
                  >全部</el-button
                >
                <el-button @click="hideTrail(1)">设定路线</el-button>
                <el-button
                  @click="hideTrail(2)"
                  v-show="SPatrolPointRecordList.length"
                  >实际路线</el-button
                >
              </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22" :offset="2">
              <span class="item_title" style="opacity: 0">坐标</span>
              <div class="table sidebar">
                <el-table
                  :data="tableData"
                  ref="multipleTable"
                  style="width: 100%"
                >
                  <el-table-column type="index" label="序号" width="80">
                  </el-table-column>
                  <el-table-column prop="name" label="巡检点">
                  </el-table-column>
                  <el-table-column prop="clockinWayName" label="打卡方式">
                  </el-table-column>
                  <el-table-column prop="clockTime" label="打卡时间">
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="center" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../apis";
import ZJApp from "../../../../app";
import { getPatrolTaskDetail } from "@/request/patrolApi";

export default {
  name: "TaskInfo",
  controller: "UI",
  action: "TaskInfo",
  data() {
    return {
      data: {},
      tableData: [],
      SPatrolPointRecordList: [],

      loading: false,
      loadingText: "加载中...",
      EqRegionArr: [],
      IsEdit: false,
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted() {
   // this.onDrawMap();
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    /*切换路线，显示选中的路线*/
    hideTrail(index) {
      let { SPatrolPointRecordList, pointMapByRouteList } = this;
      this.init(pointMapByRouteList, SPatrolPointRecordList, index);
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        getPatrolTaskDetail({ taskId: InfoId })
          .then((r) => {
            this.loading = false;
            if (r.code === 0 && r.data) {
              let { SPatrolPointRecordList, pointMapByRouteList, sPatrolTask } =
                r.data;
              this.data = sPatrolTask;
              Object.assign(this.data,JSON.parse(this.$route.query.row))
              let arr = [],
                routeLine = [];
              if (SPatrolPointRecordList) {
                this.tableData = SPatrolPointRecordList;
                if (sPatrolTask.clockintaskroutepoi) {
                  routeLine = JSON.parse(sPatrolTask.clockintaskroutepoi).map(
                    (element) => {
                      const { latitude, longitude } = element;
                      return { latitude, longitude };
                    }
                  );
                }
                SPatrolPointRecordList.map((item) => {
                  item.time = item.time || "";
                  arr.push({
                    latitude: item.latitude,
                    longitude: item.longitude,
                    time: item.time + item.name,
                  });
                });
                this.SPatrolPointRecordList = routeLine;
                pointMapByRouteList.map((item) => {
                  item.time = item.time || "";
                });
                this.pointMapByRouteList = pointMapByRouteList;
                this.init(pointMapByRouteList, arr, 0);
              }
            }
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.msg ? e.msg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    init(arr, planArr, index) {
      let mp = new BMap.Map("mymap"); //创建地图实例
      let pointArray = [],
        pois = [],
        planPois = [];
      if (arr.length && index != 2) {
        mp.centerAndZoom(new BMap.Point(arr[0].longitude, arr[0].latitude), 12);
        arr.map((item) => {
          var point = new BMap.Point(item.longitude, item.latitude);
          pointArray.push(point);
          pois.push(point);
        });
        arr.map((item) => {
          var marker = new BMap.Marker(
            new BMap.Point(item.longitude, item.latitude)
          );
          var label = new BMap.Label(item.time || item.name, {
            offset: new BMap.Size(20, -10),
          });
          label.setStyle({
            height: "0.34rem",
            lineHeight: "0.34rem",
            width: "auto",
            //border: "0.02rem solid #transparent",
            fontFamily: "微软雅黑",
            left: "60%",
            marginLeft: "-0.36rem",
            marginTop: "0.54rem",
          });
          marker.setLabel(label);
          mp.addOverlay(marker);
        });
      } else {
        if (planArr && planArr.length) {
          mp.centerAndZoom(
            new BMap.Point(planArr[0].longitude, planArr[0].latitude),
            12
          );
        }
      }
      index != 1 &&
        planArr &&
        planArr.length &&
        planArr.map((item) => {
          var point = new BMap.Point(item.longitude, item.latitude);
          pointArray.push(point);
          planPois.push(point);
        });

      mp.setViewport(pointArray, {
        margins: [30, 20, 0, 20],
      });

      var polyline = new BMap.Polyline(pois, {
        enableEditing: false, //是否启用线编辑，默认为false
        enableClicking: true, //是否响应点击事件，默认为true
        strokeWeight: "8", //折线的宽度，以像素为单位
        strokeOpacity: 0.8, //折线的透明度，取值范围0 - 1
        strokeColor: "#18a45b", //折线颜色
      });
      mp.addOverlay(polyline);
      if (planPois.length) {
        var polyline1 = new BMap.Polyline(planPois, {
          enableEditing: false, //是否启用线编辑，默认为false
          enableClicking: true, //是否响应点击事件，默认为true
          strokeWeight: "8", //折线的宽度，以像素为单位
          strokeOpacity: 0.8, //折线的透明度，取值范围0 - 1
          strokeColor: "#ff0000", //折线颜色
        });
      }
      mp.addOverlay(polyline1);
      mp.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      $(".toggles.combineToggle").hide();
    },
    onDrawMap: function () {
      this.$nextTick(function () {
        // 创建地图，并通过样式让地图填满窗口
        let that = this;
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".trailmap").zjumap({
            syscode: "ZJMap",
            key: "EmergencyOneMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            mapConfigs: {
              mapStyle: "",
              togglePanelVisiable: false,
              mapLayers: "DOM",
              clickToShowLocation: false,

              onMapCreated: function (e) {
                $(".toggles.combineToggle").hide();
                that.mapInstance = e.map;
                // e.map.clearAll();
                that.center = e.map.config.center;
                setTimeout(() => {
                  //  that.addDom();
                }, 1000);
              },
            },
          });
        });
      });
    },
  },
};
</script>
<style scoped>
#mymap {
  width: 90%;
  height: 60rem;
  overflow: hidden;
  margin: 0;
  font-family: "微软雅黑";
}
.item_title{
   width: 10%;
}
.btn {
  position: absolute;
  right: 1rem;
  top: 5rem;
}
.btn .el-button {
  color: #0b6ba3 !important;
}

</style>
